let canvas;
let ctx;
let width;
let height;

// Set up particle properties
const particleCount = 10;
const particleLife = 200;
const particleRadius = 2;
const tracerCount = 5;
const tracerLife = particleLife / tracerCount;
const tracerWidth = particleRadius / 2;
const colors = [
    "#ff0000",
    "#00ff00",
    "#0000ff",
    "#ffff00",
    "#00ffff",
    "#ff00ff"
];

// Set up particle array
let particles = [];

class Particle {
    constructor(
        x = null,
        y = null,
        vx = null,
        vy = null,
        color = null,
        life = null,
        explode = false,
        gravity = true
    ) {
        this.x =
            x !== null && x !== undefined
                ? x
                : Math.random() * (width - 400) + width * 0.1041;
        this.y = y !== null && y !== undefined ? y : height;
        this.prevX = this.x;
        this.prevY = this.y;
        this.vx =
            vx !== null && vx !== undefined
                ? vx
                : (width / 2 - this.x - (Math.random(this.x) * width) / 3.5) /
                      100 +
                  (Math.random() * 5 - 1) / 10;
        this.vy =
            vy !== null && vy !== undefined
                ? vy
                : Math.max(Math.min(Math.random() * -10 - 5, -10), -15);
        this.color =
            color !== null && color !== undefined
                ? color
                : colors[Math.floor(Math.random() * colors.length)];
        this.life = life !== null && life !== undefined ? life : 0;
        this.radius = particleRadius;
        this.explode = explode;
        this.exploded = false;
        this.gravity = gravity;
        this.lastSpawnTime = 0;
    }
    update() {
        if (this.gravity) {
            this.prevX = this.x - this.vx * 2;
            this.prevY = this.y - this.vy * 2;
            this.x += this.vx;
            this.y += this.vy;
            this.vy += 0.1;
        } else {
            // this.prevX = this.x - this.vx * 2;
            // this.prevY = this.y - this.vy * 2;
            this.x += this.vx;
            // this.y += this.vy;
            this.vy = 3;
        }
        this.life++;

        // Check if the y component of the velocity is close to zero
        if (!this.exploded && this.explode && Math.abs(this.vy) < 0.1) {
            // Create a firework effect by creating 20 subparticles that are evenly spaced around a circle
            for (let i = 0; i < 20; i++) {
                const angle = ((2 * Math.PI) / 20) * i;
                const subparticle = new Particle(
                    this.x,
                    this.y,
                    3.5 * Math.cos(angle),
                    3.5 * Math.sin(angle),
                    null,
                    particleLife / 1.3
                );
                particles.push(subparticle);
            }
            this.exploded = true;
            this.life = Infinity;
        }

        // Calculate the normalized velocity vector
        this.normalizedVelocity = this.getNormalizedVelocity();

        // Draw tracers
        if (this.life % tracerLife == 0) {
            ctx.beginPath();
            ctx.strokeStyle = this.color;
            ctx.lineWidth = tracerWidth;
            ctx.moveTo(this.x, this.y);
            ctx.lineTo(this.x + this.vx, this.y + this.vy);
            ctx.stroke();
        }
    }

    draw() {
        // Calculate the flicker value using a sine wave function
        const flicker = (Math.sin(this.life / 10) + 1) / 5;
        // Clamp the flicker value so that it is never 0
        const clampedFlicker = Math.max(flicker, 0.5);

        // Calculate the length of the particle based on the y component of the normalized velocity vector
        const length = this.normalizedVelocity.v * 5;

        // Calculate the start and end points of the particle
        const startX = this.x - (this.normalizedVelocity.x * length) / 2;
        const startY = this.y - (this.normalizedVelocity.y * length) / 2;
        const endX = this.x + (this.normalizedVelocity.x * length) / 2;
        const endY = this.y + (this.normalizedVelocity.y * length) / 2;

        // Draw the particle as an elongated line
        ctx.beginPath();
        ctx.strokeStyle = this.color;
        ctx.lineWidth = this.radius * 2;
        ctx.moveTo(startX, startY);
        ctx.lineTo(endX, endY);
        ctx.strokeStyle = `rgba(${hexToRgb(this.color)}, ${Math.max(
            1 - this.life / (particleLife * 0.95),
            0.6
        )})`;
        ctx.stroke();
    }

    // Method to calculate the normalized velocity vector
    getNormalizedVelocity() {
        const velocity = Math.sqrt(this.vx * this.vx + this.vy * this.vy);
        return {
            v: velocity,
            x: this.vx / velocity,
            y: this.vy / velocity
        };
    }

    // Method to check if the particle is dead
    isDead() {
        return this.life >= particleLife;
    }
}

function hexToRgb(hex) {
    // Extract the red, green, and blue values from the hex code
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);

    // Return the RGB value as an array
    return `${r},${g},${b}`;
}

// Function to create particles
function createParticles() {
    if (particles.length < particleCount) {
        particles.push(new Particle(null, null, null, null, null, null, true));
    }
}

// Animation loop
function animate() {
    requestAnimationFrame(animate);
    createParticles();
    ctx.clearRect(0, 0, width, height);
    particles.forEach((particle, i) => {
        particle.update();
        particle.draw();
        if (particle.isDead()) {
            // Remove the particle from the array if it is dead
            particles.splice(i, 1);
        }
    });
}

export function fire() {
    canvas = document.getElementById("fireworks-canvas");
    ctx = canvas.getContext("2d");
    width = window.innerWidth;
    height = window.innerHeight;
    canvas.width = width;
    canvas.height = height;
    animate();
}
